import axios from "axios";
import { storageFactory } from "../../../utils/storageFactory";
import { API_DETAILS } from "../configuration/config";
import { StorageHelper } from "../../../utils/storageHelper";
import * as UtilsHelper from "../../../utils/utilsHelper";
import _ from "underscore";

const localStore = storageFactory(() => sessionStorage);

if (_.isEmpty(StorageHelper.getAppSettings())) {
  UtilsHelper.loadAppSettings(true);
}
const getBaseURL = (type) => {
  switch (type) {
    case "baseViedocUrl":
      return `${StorageHelper.getAppSettings().baseViedocUrl}`;
    case "WITHOUT_VERSION":
      return `${StorageHelper.getAppSettings().baseDocumentUrl}`;
    case "EXPORT":
      return `${StorageHelper.getAppSettings().baseTemplateUrl}`;

    default:
      return `${StorageHelper.getAppSettings().baseTemplateUrl}${API_DETAILS.service_api}`;
  }
};

export const API = axios.create({
  baseURL: `${StorageHelper.getAppSettings() && StorageHelper.getAppSettings().baseDocumentUrl}${API_DETAILS.service_api}`,
});

API.interceptors.request.use(async (request) => {
  if (
    request.type === "baseViedocUrl" ||
    request.type === "baseTemplateUrl" ||
    request.type === "WITHOUT_VERSION" ||
    request.type === "EXPORT"
  ) {
    request.baseURL = getBaseURL(request.type);
  }
  request.headers.Authorization = "Bearer " + localStore.getItem("jwtToken");
  return request;
});

API.interceptors.response.use(
  async (response) => {
    return response;
  },
  (error) => {
    if (401 !== error.response.status) {
      return error.response;
    } else {
      // errorHandler(error);
    }
  }
);
